import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LocationStockRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("locationstock");
